import { DropdownOption } from '../types/dropdown';

/**
 * 獲取攪拌廠位置完整名稱
 * @param locationKey 位置鍵值
 * @param mixingPlantLocations 攪拌廠位置選項數組
 * @returns 完整名稱字符串
 */
export const getMixingPlantLocationFullName = (
  locationKey: string,
  mixingPlantLocations: DropdownOption[]
): string => {
  if (!locationKey || !mixingPlantLocations.length) {
    return locationKey || '';
  }

  const location = mixingPlantLocations.find(loc => loc.LIST_KEY === locationKey);
  if (location) {
    return `${location.LIST_KEY} - ${location.LIST_DESCRIPTION || location.LIST_NAME}`;
  }

  return locationKey;
};

export const getMixingPlantLocationFullNameWithoutCode = (
    locationKey: string,
    mixingPlantLocations: DropdownOption[]
  ): string => {
    if (!locationKey || !mixingPlantLocations.length) {
      return locationKey || '';
    }

    const location = mixingPlantLocations.find(loc => loc.LIST_KEY === locationKey);
    if (location) {
      return `${location.LIST_DESCRIPTION || location.LIST_NAME}`;
    }

    return locationKey;
  };

/**
 * 獲取混凝土供應商完整名稱
 * @param supplierKey 供應商鍵值
 * @param concreteSuppliers 混凝土供應商選項數組
 * @returns 完整名稱字符串
 */
export const getConcreteSupplierFullName = (
  supplierKey: string,
  concreteSuppliers: DropdownOption[]
): string => {
  if (!supplierKey || !concreteSuppliers.length) {
    return supplierKey || '';
  }

  const supplier = concreteSuppliers.find(sup => sup.LIST_KEY === supplierKey);
  if (supplier) {
    return `${supplier.LIST_KEY} - ${supplier.LIST_DESCRIPTION || supplier.LIST_NAME}`;
  }

  return supplierKey;
};

export const getConcreteSupplierFullNameWithoutCode = (
    supplierKey: string,
    concreteSuppliers: DropdownOption[]
  ): string => {
    if (!supplierKey || !concreteSuppliers.length) {
      return supplierKey || '';
    }

    const supplier = concreteSuppliers.find(sup => sup.LIST_KEY === supplierKey);
    if (supplier) {
      return `${supplier.LIST_DESCRIPTION || supplier.LIST_NAME}`;
    }

    return supplierKey;
  };
/**
 * 獲取水泥類型完整名稱
 * @param typeKey 類型鍵值
 * @param cementTypes 水泥類型選項數組
 * @returns 完整名稱字符串
 */
export const getCementTypeFullName = (
  typeKey: string,
  cementTypes: DropdownOption[]
): string => {
  if (!typeKey || !cementTypes.length) {
    return typeKey || '';
  }

  const type = cementTypes.find(t => t.LIST_KEY === typeKey);
  if (type) {
    return `${type.LIST_KEY} - ${type.LIST_DESCRIPTION || type.LIST_NAME}`;
  }

  return typeKey;
};

/**
 * 獲取水泥來源完整名稱
 * @param sourceKey 來源鍵值
 * @param cementSources 水泥來源選項數組
 * @returns 完整名稱字符串
 */
export const getCementSourceFullName = (
  sourceKey: string,
  cementSources: DropdownOption[]
): string => {
  if (!sourceKey || !cementSources.length) {
    return sourceKey || '';
  }

  const source = cementSources.find(s => s.LIST_KEY === sourceKey);
  if (source) {
    return `${source.LIST_DESCRIPTION || source.LIST_NAME}`;
  }

  return sourceKey;
};

/**
 * 獲取PFA來源完整名稱
 * @param sourceKey 來源鍵值
 * @param pfaSources PFA來源選項數組
 * @returns 完整名稱字符串
 */
export const getPfaSourceFullName = (
  sourceKey: string,
  pfaSources: DropdownOption[]
): string => {
  if (!sourceKey || !pfaSources.length) {
    return sourceKey || '';
  }

  const source = pfaSources.find(s => s.LIST_KEY === sourceKey);
  if (source) {
    return `${source.LIST_DESCRIPTION || source.LIST_NAME}`;
  }

  return sourceKey;
};

/**
 * 獲取GGBS來源完整名稱
 * @param sourceKey 來源鍵值
 * @param ggbsSources GGBS來源選項數組
 * @returns 完整名稱字符串
 */
export const getGgbsSourceFullName = (
  sourceKey: string,
  ggbsSources: DropdownOption[]
): string => {
  if (!sourceKey || !ggbsSources.length) {
    return sourceKey || '';
  }

  const source = ggbsSources.find(s => s.LIST_KEY === sourceKey);
  if (source) {
    return `${source.LIST_DESCRIPTION || source.LIST_NAME}`;
  }

  return sourceKey;
};

/**
 * 獲取骨料來源完整名稱
 * @param sourceKey 來源鍵值
 * @param aggregateSources 骨料來源選項數組
 * @returns 完整名稱字符串
 */
export const getAggregateSourceFullName = (
  sourceKey: string,
  aggregateSources: DropdownOption[]
): string => {
  if (!sourceKey || !aggregateSources.length) {
    return sourceKey || '';
  }

  const source = aggregateSources.find(s => s.LIST_KEY === sourceKey);
  if (source) {
    return `${source.LIST_DESCRIPTION || source.LIST_NAME}`;
  }

  return sourceKey;
};

export const getAggregateTypeFullName = (
  typeKey: string,
  aggregateSources: DropdownOption[]
): string => {
  if (!typeKey || !aggregateSources.length) {
    return typeKey || '';
  }

  const source = aggregateSources.find(s => s.LIST_KEY === typeKey);
  if (source) {
    return `${source.LIST_DESCRIPTION || source.LIST_NAME}`;
  }

  return typeKey;
};

export const getAdmixtureSourceFullName = (
  sourceKey: string,
  admixtureSources: DropdownOption[]
): string => {
  if (!sourceKey || !admixtureSources.length) {
    return sourceKey || '';
  }

  const source = admixtureSources.find(s => s.LIST_KEY === sourceKey);
  if (source) {
    return `${source.LIST_DESCRIPTION || source.LIST_NAME}`;
  }

  return sourceKey;
};

/**
 * 通用下拉選項完整名稱獲取函數
 * @param key 鍵值
 * @param options 選項數組
 * @returns 完整名稱字符串
 */
export const getDropdownOptionFullName = (
  key: string,
  options: DropdownOption[]
): string => {
  if (!key || !options.length) {
    return key || '';
  }

  const option = options.find(opt => opt.LIST_KEY === key);
  if (option) {
    return `${option.LIST_KEY} - ${option.LIST_DESCRIPTION || option.LIST_NAME}`;
  }

  return key;
};
